export const ValidationStatusEnum = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
  FAILED: 'FAILED',
};
